import React from "react";
import {
  CheckoutBaseModal,
  CheckoutBaseModalItem,
} from "./checkout.base.modal";

interface CheckoutLaybuyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const columns: CheckoutBaseModalItem[] = [
  {
    iconName: "laybuy_cursor",
    title: "Pay by Laybuy.",
    content: "Proceed to checkout. Select Laybuy as your payment method.",
  },
  {
    iconName: "laybuy_lb_heart",
    title: "Complete order.",
    content: "Log in or sign up. Complete your order in seconds.",
  },
  {
    iconName: "laybuy_calendar",
    title: "Select schedule.",
    content: "Choose your payment day. View your schedule and select pay now.",
  },
  {
    iconName: "laybuy_sunglasses",
    title: "You're done.",
    content:
      "Your items are on their way. Payments will be taken automatically each week.",
  },
];

export const CheckoutLaybuyModal = ({
  isOpen,
  onClose,
}: CheckoutLaybuyModalProps) => {
  const intro =
    "Deciding what to buy is hard, but paying for it doesn't have to be. Laybuy lets you receive the item now and spread the payment over 6 weekly automatic instalments. Interest free!";

  return (
    <CheckoutBaseModal
      isOpen={isOpen}
      onClose={onClose}
      columns={columns}
      intro={intro}
      colour={"#786dff"}
      icon={"laybuy"}
    />
  );
};
